export default __webpack_public_path__ + "locales/sq-AL/DeleteProfileEverDialog.json?hash=e30d95e86d5e7a442911aa56c3076900";